import { useRouter } from 'next/router';
import { useMemo } from 'react';

import {
  LelandSessionStorage,
  REFERRAL_CODE_KEY,
  REFERRAL_TYPE_KEY,
} from '../storage';

export const useReferralParameters = () => {
  const router = useRouter();

  const { referralCode, referralType } = useMemo(
    () => getReferralParameters(router),
    [router],
  );

  return { referralCode, referralType };
};

const getReferralParameters = (router: {
  query: Record<string, string | string[] | undefined>;
}) => {
  return {
    referralCode: getRefParameter(
      router.query,
      'referralCode',
      REFERRAL_CODE_KEY,
    ),
    referralType: getRefParameter(
      router.query,
      'referralType',
      REFERRAL_TYPE_KEY,
    ),
  };
};

const getRefParameter = (
  routerQuery: Record<string, string | string[] | undefined>,
  paramName: string,
  storageKey: string,
): string | undefined => {
  const queryValue = routerQuery[paramName] as string | undefined;
  const storageValue = LelandSessionStorage.getItem<string>(storageKey);

  const normalizedQueryValue = queryValue === '' ? undefined : queryValue;
  const normalizedStorageValue = storageValue === '' ? undefined : storageValue;

  return normalizedQueryValue ?? normalizedStorageValue ?? undefined;
};
